module.exports = __webpack_public_path__ + "img/eventDelivery0428.9f8e7c87.jpg";